<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="calificacion-grupo" titulo="Calificación / Control Escolar" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
  <div class="column is-2 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; height:100%;">

      <!-- formulario -->
      <form name="form" novalidate (ngSubmit)="ctrl.enviar()">
        <section class="hero is-primary">
          <div class="hero-body">

            <!-- Opciones  -->
            <section class="hero is-primary">
              <div class="hero-head">
                <nav class="level">
                  <!-- Left side -->
                  <div class="level-left">
                    <div class="level-item">
                      <p class="title">
                        <span *ngIf="!ctrl.cargando" class="icon is-medium">
                          <i class="icon-files2"></i>
                        </span>
                        <span *ngIf="ctrl.cargando  || cargando" class="icon is-medium">
                          <i class="icon-worldwide fa-spin"></i>
                        </span>
                        <span class="icon is-medium">
                          <i class="icon-file"></i>
                        </span> Calificaciones (Reprobados)
                      </p>
                    </div>

                  </div>

                  <!-- Right side -->
                  <div class="level-right">

                    <a class="navbar-item is-primary tooltip" (click)="ctrl.regresar()">
                      <span class="icon fa-2x">
                        <i class="icon-back"> </i>
                      </span>
                      <span class="tooltiptext">Regresar</span>
                    </a>

                    <a class="navbar-item is-primary tooltip" id="actualizar" (click)="cargarDatos(materia, ctrl.periodo_escolar, ctrl.profesor, ctrl.grupo);">
                      <span class="icon fa-2x">
                        <i class="icon-worldwide"></i>
                      </span>
                      <span class="tooltiptext">Actualizar</span>
                    </a>

                    <button class="navbar-item  tooltip" type="button" [ngClass]="{'is-loading': cargando}" [disabled]="cargando"
                      (click)="ctrl.abrirModal('confirmarCalificacion')">
                      <span class="icon fa-2x has-text-success">
                        <i class="icon-diskette"> </i>
                      </span>
                      <span class="tooltiptext">Guardar</span>
                    </button>
                  </div>
                </nav>
              </div>
            </section>
          </div>
        </section>

        <a id="catalogos" (click)="ctrl.cargarCatalogo('periodos_escolares', 'periodo-escolar-catalogo', '', 'cargando_periodo'); ctrl.cargarCatalogo('profesores', 'profesores-calificaciones');"></a>
        <a id="CaragarLogos" (click)="ctrl.cargarCatalogo('logos64', 'logos64?carreras_planes_id='+carrera_plan.id, 'logo64');"></a>
        <a id="logo64" (click)="asignarLogos(ctrl.logos64); "></a>
        <div id="banner" align="center" *ngIf="ctrl.cargando || ctrl.cargarDatosCatalogo || cargando">
          <div class="bloquear-azul">

          </div>
          <span class="tag is-primary is-large " style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
            <span class="icon">
              <i class="icon-worldwide fa-spin"></i>
            </span> &nbsp;
            <span>Cargando...</span>
          </span>
        </div>

        <section class="section" style="padding: 1rem; height: 87.2vh;">

          <div class="columns">
            <div class="column is-6">
              <label class="label">Período escolar: </label>
              <div class="control has-icons-left has-icons-right">

                <span class="icon is-small is-left">
                  <i class="icon-worldwide fa-spin" *ngIf="ctrl.cargando_periodo"></i>
                </span>

                <ng-select2 [disabled]="ctrl.periodos_escolares ? ctrl.periodos_escolares.length == 0 ? true : false : true"
                  [options]="ctrl.optionSelect" ([ngModel])="periodo_escolar"
                  (valueChanged)="ctrl.grupos = []; ctrl.profesores = []; ctrl.materias = []; ctrl.seleccionarValorSelect2($event, 'periodo_escolar', 'grupos-calificaciones', 'grupos');"
                  [data]="ctrl.periodos_escolares"></ng-select2>
              </div>
            </div>
            <div class="column is-6">
              <label class="label">Grupo:</label>
              <div class="control has-icons-left has-icons-right">
                <ng-select2 [disabled]="ctrl.grupos ? ctrl.grupos.length == 0 ? true : false : true" [options]="ctrl.optionSelect"
                  ([ngModel])="grupo"
                  (valueChanged)="ctrl.profesores = []; ctrl.materias = [];  ctrl.seleccionarValorSelect2($event, 'grupo', 'profesores-calificaciones?periodo='+ctrl.periodo_escolar, 'profesores');"
                  [data]="ctrl.grupos"></ng-select2>
              </div>
            </div>

          </div>
          <div class="columns">

            <div class="column is-6">
              <label class="label">Docente:</label>
              <div class="control has-icons-left has-icons-right">

                <ng-select2 [disabled]="ctrl.profesores ? ctrl.profesores.length == 0 ? true : false : true"
                  [options]="ctrl.optionSelect" ([ngModel])="profesor"
                  (valueChanged)="ctrl.materias = []; ctrl.seleccionarValorSelect2($event, 'profesor', 'materias-calificaciones?periodo='+ctrl.periodo_escolar+'&grupo='+ctrl.grupo, 'materias');"
                  [data]="ctrl.profesores"></ng-select2>
              </div>
            </div>

            <div class="column is-6">
              <label class="label">Materia:</label>
              <div class="control has-icons-left has-icons-right">
                <ng-select2 [disabled]="ctrl.materias ? ctrl.materias.length == 0 ? true : false : true"
                  [options]="ctrl.optionSelect" ([ngModel])="materia"
                  (valueChanged)="cargarDatos($event, ctrl.periodo_escolar, ctrl.profesor, ctrl.grupo);"
                  [data]="ctrl.materias"></ng-select2>
              </div>
            </div>

          </div>

          <div class="box" *ngIf="carrera_plan">
            <article class="media">
              <div class="media-content">
                <nav class="level">
                  <div lass="level-left">
                    <div class="level-item">
                      <p align="center">

                        <strong> Carrera Plan:</strong> {{carrera_plan.planes_estudios.nombre}}
                        <strong> Carrera:</strong> {{carrera_plan.carreras.nombre}}
                        <br>
                        <strong> Modalidad:</strong> {{grupo.periodos_escolares.modalidades.nombre}}
                        <span> Grupo: {{grupo.clave}}</span>
                        <span> Nivel: {{grupo.nivel}} {{grupo.identificador}}</span>

                      </p>
                    </div>
                  </div>
                  <div class="level-right" style="margin-right: 35px;">

                    <button class="navbar-item  tooltip" type="button" (click)="imprimirCalificacion(true)" >
                      <span class="icon fa-2x has-text-link">
                        <i class="icon-printer"></i>
                      </span>
                      <span class="tooltiptext">Imprimir Calificaciones</span>
                    </button>

                  </div>
                </nav>

                <div class="content" style="overflow-y:auto;height: 52vh;">
                  <table class="table is-striped is-fullwidth">
                    <thead>
                      <tr>
                        <th><abbr>ID</abbr></th>
                        <th>Nombre Alumno</th>
                        <th *ngFor="let item of opciones_calificacion; let i=index"> {{ item.nombre }}</th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of dato; let i=index">
                        <td style="vertical-align: middle;">{{ i + 1 }}</td>
                        <td style="vertical-align: middle;">{{item.alumno.nombre}}</td>
                        <td *ngFor="let parcial of opciones_calificacion; let v=index">
                          <input class="input" type="number" min="0"
                            [max]="grupo.carreras_planes_modulos.maximo_aprobatorio"
                            [step]="grupo.periodos_escolares.modalidades.materia_numero_decimales"
                            [(ngModel)]="item.calificaciones[parcial.id].promedio"
                            (keyup)="validar_max($event, item.calificaciones[parcial.id].promedio, grupo.carreras_planes_modulos.maximo_aprobatorio)"
                            [ngModelOptions]="{standalone: true}" [disabled]="item.calificaciones[parcial.id].disabled">
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </article>
          </div>

        </section>
      </form>
    </div>
  </div>
</div>


<div class="modal" id="confirmarCalificacion">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <i class="fa fa-warning"></i> Alerta</p>
      <button class="delete" (click)="ctrl.cancelarModal('confirmarCalificacion')"></button>
    </header>
    <section class="modal-card-body">
      <div class="content">
        <h1>¿Esta seguro de guardar los cambios?</h1>
        <p>Esta acción podra afectar boletas impresas anteriormente</p>
      </div>
    </section>
    <footer class="modal-card-foot">
      <a class="button is-success" (click)="enviar()" [ngClass]="{'is-loading': borrarCargando}">Continuar</a>
      <a class="button" (click)="ctrl.cancelarModal('confirmarCalificacion')">Cerrar</a>
    </footer>
  </div>
</div>
